import { useState } from "react";
import { useParams } from "react-router-dom";

import { publicUserAPI } from "../../api/publicUser";
import { useGeneralErrorHandlerCreator } from "../../common/hooks/useGeneralErrorHandler";
import { FormSubmissionHandler } from "../../types/common";
import { GenericError, composeErrorHandlers } from "../../utils/errorHandling";

import ResetPasswordForm, {
    ResetPasswordFormValues,
} from "./components/ResetPasswordForm";
import ResetPasswordInvalidMessage from "./components/ResetPasswordInvalidMessage";
import ResetPasswordSuccessMessage from "./components/ResetPasswordSuccessMessage";

enum ResetPasswordState {
    Input,
    Success,
    Invalid,
}

const ResetPasswordView = (): JSX.Element => {
    const [state, setState] = useState(ResetPasswordState.Input);
    const { token } = useParams<{ token: string }>();

    const useGeneralError = useGeneralErrorHandlerCreator();

    const handleSubmit: FormSubmissionHandler<ResetPasswordFormValues> = async (
        values,
        { setSubmitting },
    ) => {
        setSubmitting(true);
        if (token) {
            try {
                await publicUserAPI.resetPassword(token, values.password);
                setState(ResetPasswordState.Success);
            } catch (err) {
                composeErrorHandlers(useGeneralError)(err as GenericError);
            }
        }
        setSubmitting(false);
    };

    switch (state) {
        case ResetPasswordState.Input:
            return <ResetPasswordForm onSubmit={handleSubmit} />;
        case ResetPasswordState.Success:
            return <ResetPasswordSuccessMessage />;
        case ResetPasswordState.Invalid:
            return <ResetPasswordInvalidMessage />;
    }
};

export default ResetPasswordView;
